import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({ title: "404 — Off the Grid | Licence to Play", description: "Page not found." });
  return (
    <div className="max-w-3xl mx-auto px-5 py-32 text-center">
      <p className="overline text-crimson-bright mb-4">Signal Lost // 404</p>
      <h1 className="font-display text-5xl sm:text-6xl text-white tracking-tighter">Off the grid.</h1>
      <p className="mt-5 text-white/60 leading-relaxed">
        This briefing has either been redacted or never existed. Let's get you back to safe ground.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 border border-gold text-gold font-semibold text-sm hover:bg-gold hover:text-black transition-colors"
      >
        <ArrowLeft className="w-4 h-4" /> Return to HQ
      </Link>
    </div>
  );
}
